import authUtils from './helpers/authUtils';

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const { getCaRTT } = authUtils;

export function register() {
  if ('serviceWorker' in navigator) {
    return new Promise((resolve, reject) => {
      navigator.serviceWorker.register(`${window.location.origin}/service-worker-http.js`)
        .then((reg) => {
          if (reg.active) {
            const cartt = getCaRTT();
            reg.active.postMessage({ token: cartt });
            resolve(reg);
          } else {
            reg.addEventListener('updatefound', () => {
              if (reg.active) {
                window.location.reload();
              }
            });
          }
        }).catch((error) => {
          console.error(`Registration failed with ${error}`);
          reject(error);
        });
    });
  }

  return Promise.resolve(false);
}

export function unregister() {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    return new Promise<void>((resolve) => {
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.unregister();
          resolve();
        })
        .catch((error) => {
          console.error(error.message);
          resolve();
        });
    });
  }

  return Promise.resolve();
}

export const prepareServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.controller) {
      return new Promise<void>((resolve) => {
        navigator.serviceWorker.ready
          .then((reg) => {
            if (reg.active) {
              const cartt = getCaRTT();
              reg.active.postMessage({ token: cartt });
            }
            resolve();
          });
      });
    }
  }

  return Promise.resolve(false);
};
